import { render, staticRenderFns } from "./SimsSolicitudes.vue?vue&type=template&id=45ac452e&"
import script from "./SimsSolicitudes.vue?vue&type=script&lang=ts&"
export * from "./SimsSolicitudes.vue?vue&type=script&lang=ts&"
import style0 from "./SimsSolicitudes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports